<template>
  <div>
    <div class="detail">
      <div class="title">
        放假计划：
        <span class="btn">
          <a-button type="primary" @click="$refs.LessonPlanModal.init('add')">
            新增
          </a-button>
        </span>
      </div>
      <!-- 表格数据 -->
      <a-table
        :loading="loading"
        bordered
        :columns="columns"
        :dataSource="lessonPlanData"
        :pagination="pagination"
        @change="tableChange"
        :rowKey="getRowKey"
      >
      </a-table>
      <!-- 弹框 -->
    </div>
    <LessonPlanModal
      :currentPageParent="pagination"
      ref="LessonPlanModal"
    ></LessonPlanModal>
  </div>
</template>

<script>
import education from '../../api/education'
import LessonPlanModal from './LessonPlanModal.vue'
import Vue from 'vue'
import LoginVue from '../user/Login.vue'
const columns = [
  {
    title: '放假计划名称',
    dataIndex: 'planName',
  },
  {
    title: '放假开始日期',
    dataIndex: 'startDate',
  },
  {
    title: '放假结束日期',
    dataIndex: 'endDate',
  },
  {
    title: '放假天数',
    dataIndex: 'days',
  },
  {
    title: '创建日期',
    dataIndex: 'createDate',
  },
]
export default {
  name: 'lessonPan',
  components: {
    LessonPlanModal,
  },
  data() {
    return {
      schoolId: Vue.ls.get('schoolId'),
      columns,
      lessonPlanData: [],
      loading: true,
      pagination: {
        pageSize: 10,
        total: 0,
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        current: 1,
        currentPage: 1,
      }, //分页数据对象
    }
  },
  created() {
    if (this.$route.query.params) {
      this.pagination = JSON.parse(this.$route.query.params)
    }
    this.getCourseList({
      schoolId: Vue.ls.get('schoolId'),
      currentPage: this.pagination.current,
      pageSize: this.pagination.pageSize,
    })
  },
  methods: {
    getCourseList(data) {
      if (data.currentPage == undefined) {
        data.currentPage = 1
      }
      this.loading = true
      console.log('data', data)
      education.getLessonList(data).then((res) => {
        this.loading = false
        // console.log('getLessonListres', res)
        this.lessonPlanData = res.data.list
        this.pagination = res.data.pagination
      })
    },
    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      this.pagination = pagination

      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        this.pagination
      )}`
      this.getCourseList({
        schoolId: Vue.ls.get('schoolId'),
        currentPage: pagination.current,
        pageSize: pagination.pageSize,
      })
    },
    getRowKey(record, index) {
      return index;
    },
  },
}
</script>

<style lang="scss" scoped>
.detail {
  margin-left: 10px;
  margin-top: 20px;
  margin-right: 100px;
  .title {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .ant-table-wrapper {
    margin-bottom: 20px;
  }
}
</style>
